import { render, staticRenderFns } from "./StatsApp.vue?vue&type=template&id=31b65f22&"
import script from "./StatsApp.vue?vue&type=script&lang=js&"
export * from "./StatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports